(function (jQuery) {
  // jQuery('.accordion > li:eq(0) a').addClass('active').next().slideDown();

  jQuery('.js-accordion-btn').on('click', function (j) {
    var dropDown = jQuery(this).closest('li').find('.js-accordion-content');
    jQuery(this)
      .closest('.js-accordion-container')
      .find('.js-accordion-content')
      .not(dropDown)
      .slideUp();

    if (jQuery(this).hasClass('active')) {
      jQuery(this).removeClass('active');
      jQuery(this).closest('li').removeClass('active');
    } else {
      jQuery(this).closest('.js-accordion-container').find('.js-accordion-btn.active').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.js-accordion-container').find('li').removeClass('active')
      jQuery(this).closest('li').addClass('active');
    }

    dropDown.stop(false, true).slideToggle();

    j.preventDefault();
  });
})(jQuery);
